
        import * as module0 from './controllers/remove_controller.js';import * as module1 from './controllers/simple_countdown_controller.js';import * as module2 from './controllers/toggle_controller.js'
        const modules = {
            "./controllers/remove_controller.js": module0,
            "./controllers/simple_countdown_controller.js": module1,
            "./controllers/toggle_controller.js": module2,
        };
        export default modules;
      